package at.apa.statistictracker.db

import kotlin.String

public data class UserPropertyTable(
  public val userPropertyTypeTag: String,
  public val value_: String
) {
  public override fun toString(): String = """
  |UserPropertyTable [
  |  userPropertyTypeTag: $userPropertyTypeTag
  |  value_: $value_
  |]
  """.trimMargin()
}
